import Backoffice from "@snark/backoffice"
import {treatMissingData} from "@/helpers/actions";
import ModalInviteAdmin from "@/components/ModalInviteAdmin.vue";

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "organization",
	collection: "organization",
	idProperty: "_id",
	section: "app",
	pagination: 50,
	backTextFilterList: true,
	labels: {"singleTitle":"Organization","listTitle":"Organizations"},
	emptyItem: {"currentSquad":[]},
	viewActions: [
		{
			label: "Invite admin to this organization",
			cssClass: "Good",
			action: async function(organization) {
				return new Promise((resolve, _reject) => {
					this.appendComponent(ModalInviteAdmin, this, {
						organization,
						onTerminated: (userId) => {
							console.log("USER ID: ", userId);
							if(userId) {
								resolve({redirect: {path: "/user/view/" + userId}});
							}
						}
					});
				});
			}
		},
	],
	fields: [
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "creatorId",
			label: "Creator Id",
			hideOnCreate: true,
		},
		{
			name: "companyName",
			label: "Company Name",
		},
		{
			name: "type",
			label: "Type",
			formatter: Backoffice.formatters.mapping({"club": "Club", "agency": "Agency"}),
			editor: {type: "select", options: [{value: "club", label: "Club"}, {value: "agency", label: "Agency"}]},
		},
		{
			name: "hudlTeamId",
			label: "Hudl Team Id",
		},
		{
			name: "siret",
			label: "Siret",
		},
		{
			name: "address",
			label: "Address",
		},
		{
			name: "creationDate",
			label: "Creation Date",
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
			editor: {type: "date"},
		},
		{
			name: "shortName",
			label: "Short Name",
		},
		{
			name: "countryId",
			label: "Country Id",
		},
		{
			name: "countryName",
			label: "Country Name",
		},
		{
			name: "gender",
			label: "Gender",
			formatter: Backoffice.formatters.mapping({"male": "Male", "female": "Female", "mixed": "Mixed"}),
			editor: {type: "select", options: [{value: "male", label: "Male"}, {value: "female", label: "Female"}, {value: "mixed", label: "Mixed"}]},
		},
		{
			name: "currentSquad",
			label: "Current Squad",
			list: true,
			children: [
				{
					name: "playerId",
					label: "Player Id",
				},
				{
					name: "playerName",
					label: "Player Name",
				},
				{
					name: "playerNumber",
					label: "Player Number",
				},
			],
		},
		{
			name: "state",
			label: "State",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.mapping({"deleted": "Deleted", "draft": "Draft"}),
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "companyName",
			label: "Company Name",
		},
		{
			name: "type",
			label: "Type",
			formatter: Backoffice.formatters.mapping({"club": "Club", "agency": "Agency"}),
		},
		{
			name: "hudlTeamId",
			label: "Hudl Team Id",
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};